import Node from '../node.js';
import Connector, { PARAM_TYPE } from '../connector.js';

export default class NodeExpression extends Node
{
	constructor(pParent)
	{
		super(pParent);
		this.addInput(PARAM_TYPE.EXPRESSION, 'expression', '1.0', { isConnectorHidden: true });
		this.addOutput(PARAM_TYPE.ANY, 'result');
	}
	
	getType()
	{
		return 'expression';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{	
		// We need to exclude our own main expression name
		const allButMainInputNames = this.getInputNames().filter(name => name != 'expression');
		return Connector.evaluateExpression(inputValues['expression'], allButMainInputNames, inputValues, 'expression');
	}
}
